import ReactMarkdown from "react-markdown";
import MarkDownStyles from "./RichTextFormatter.module.scss";
import gfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
function RichTextFormatter({ rawText, isUserMessage, indent = true }) {
  const colorAndBgStyles = isUserMessage
    ? MarkDownStyles.userMessage
    : MarkDownStyles.botMessage;
  return (
    <ReactMarkdown
      className={`${MarkDownStyles.richText} ${colorAndBgStyles} ${!indent && MarkDownStyles.noIndent}`}
      children={rawText}
      rehypePlugins={[gfm, rehypeRaw]}
    />
  );
}

export default RichTextFormatter;
